import DetailsDialogController from '../../controllers/DetailsDialogController.js'

export default class CampaignDetailsContrller extends DetailsDialogController {
  constructor ($mdDialog, ManagementService, ToastService, IdentityService) {
    'ngInject'
    super(...arguments)
    this.entityName = 'campaign'
    this.service = IdentityService.Campaign.fetch.one(this.entity.uuid)
    this.fetchEntity()
  }
}
